import api from "../utils/axios/axiosConfig";

const auditLogService = {
  stats:      ()       => api.get("/audit-logs/stats"),
  search:     (params) => api.post("/audit-logs/search", params),
  getActions: ()       => api.get("/audit-logs/actions"),
};

export default auditLogService;
